import { GeneralHelper } from './general-helper';
import { ApiResponse } from './interfaces/api-response';

export class ApiHelper {
  private constructor() {}

  static isApiResponse<T>(obj: any): obj is ApiResponse<T> {
    return (
      obj != null &&
      GeneralHelper.hasOwnProperty(obj, 'success') &&
      GeneralHelper.hasOwnProperty(obj, 'message') &&
      GeneralHelper.hasOwnProperty(obj, 'entity')
    );
  }

  // some endpoints return an entity if call was successful or an ApiResponse containing the error message if call was unsuccessful,
  // this method can help process these more conveniently
  static handleEntityOrApiResponse<T>(
    response: T | ApiResponse<T>,
    successCallback: (entity: T) => void,
    errorCallback: (apiResponse: ApiResponse<T>) => void
  ) {
    if (ApiHelper.isApiResponse(response)) {
      if (!response.success) {
        errorCallback(response);
      } else {
        successCallback(response.entity);
      }
    } else {
      successCallback(response);
    }
  }
}
